import { ComparisonOperators } from '@contentsquare/fov-constants';
export const osVersionCondition = {
    id: 'osVersion',
    category: 'technology',
    value: {
        osVersions: [],
        operatorValues: [
            { value: ComparisonOperators.MATCH_NOT_EQUALS, label: 'CONDITION_SELECT_IS_NOT' },
            { value: ComparisonOperators.MATCH_GT, label: 'CONDITION_SELECT_MORE_THAN' },
            { value: ComparisonOperators.MATCH_LT, label: 'CONDITION_SELECT_LESS_THAN' },
            { value: ComparisonOperators.MATCH_GTE, label: 'CONDITION_SELECT_GREATER_OR_EQUAL' },
            { value: ComparisonOperators.MATCH_LTE, label: 'CONDITION_SELECT_LESS_OR_EQUAL' },
            { value: ComparisonOperators.MATCH_EQUALS, label: 'CONDITION_SELECT_EXACTLY' },
        ],
    },
};
//# sourceMappingURL=os-version-condition.value.js.map